import React from "react";
import SkeletonCard from "./BasicSkeleton/SkeletonCard";
import SkeletonElement from "./BasicSkeleton/SkeletonElement";
import SkeletonAnimation from "./BasicSkeleton/SkeletonAnimation";

const MarketPlaceSkeleton = () => {
  return (
    <div className="market-place-skeleton">
      <div className="d-flex justify-content-between">
        <div className="animation-wrapper">
          <SkeletonElement type="button" />
          <SkeletonAnimation />
        </div>
      </div>
      <div className="d-flex justify-content-between">
        <div className="filter-skeleton d-none d-lg-block">
          <div className="skeleton-card large">
            <div className="d-flex justify-content-between align-items-center class">
              <SkeletonElement type="button me-2" />
              <SkeletonElement type="button" />
            </div>
            <div className="d-flex justify-content-between align-items-center level">
              <SkeletonElement type="button me-2" />
              <SkeletonElement type="button" />
            </div>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <SkeletonElement type="title" />
                <SkeletonElement type="svg" />
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button visual-attribute" />
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <SkeletonElement type="title" />
                <SkeletonElement type="svg" />
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button visual-attribute" />
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <SkeletonElement type="title" />
                <SkeletonElement type="svg" />
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button visual-attribute" />
              </div>
            </div>

            <div>
              <div className="d-flex justify-content-between align-items-center">
                <SkeletonElement type="title" />
                <SkeletonElement type="svg" />
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button visual-attribute" />
              </div>
            </div>
            <div>
              <div className="d-flex justify-content-between align-items-center">
                <SkeletonElement type="title" />
                <SkeletonElement type="svg" />
              </div>
              <div className="d-flex justify-content-between align-items-center flex-wrap my-3">
                <SkeletonElement type="button me-2 visual-attribute" />
                <SkeletonElement type="button me-2 visual-attribute" />
              </div>
            </div>

            <SkeletonAnimation />
          </div>
        </div>
        <div className="card-container w-100 ms-lg-4">
          <div className="d-flex justify-content-between align-items-center ms-4 me-5 sort">
            <SkeletonElement type="title" />
            <SkeletonElement type="button" />
          </div>
          <div className="card-list">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketPlaceSkeleton;
